/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Stripe_HintInputs */

const fr_membership_stripe_hint = /** @type {(inputs: Membership_Stripe_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géré par l'abonnement en ligne (Stripe)`)
};

/**

* @param {Membership_Stripe_HintInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_stripe_hint = /** @type {((inputs?: Membership_Stripe_HintInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Stripe_HintInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_stripe_hint(inputs)
});